import React from 'react';
import { openSocialUrl } from '../../utils/socialLinks';

/**
 * SocialLink — <a> that prefers native YouTube / Facebook / Instagram apps on mobile.
 *
 * Props: same as <a> (href, className, aria-label, children, …).
 * Always sets rel="noopener noreferrer". Keeps https href for right-click / SEO.
 */
const SocialLink = ({ href, onClick, children, ...rest }) => {
  const handleClick = (e) => {
    if (typeof onClick === 'function') onClick(e);
    if (e.defaultPrevented) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (e.button != null && e.button !== 0) return;

    const url = href != null ? String(href).trim() : '';
    if (!url) return;

    e.preventDefault();
    openSocialUrl(url);
  };

  return (
    <a
      {...rest}
      href={href || undefined}
      rel="noopener noreferrer"
      onClick={handleClick}
    >
      {children}
    </a>
  );
};

export default SocialLink;
